import PropTypes from "prop-types";

export const khaltiProps = {
  amount: PropTypes.string.isRequired,
  data:PropTypes.array.isRequired
};
